import { SET_SAVE_BAR_DIRTY } from 'states/constants';

const initialState = {
  isDirty: false,
};

export const saveBarReducer = (state = initialState, action) => {
  switch (action?.type) {
    case SET_SAVE_BAR_DIRTY:
      return { ...state, isDirty: Boolean(action?.payload) };
    default:
      return state;
  }
};
